export const IconFamilyEnum = {
    /**Value: 'ai'.*/
    AntDesignIcons: "ai",
    /**Value: 'bs'.*/
    BootstrapIcons: "bs",
    /**Value: 'bi'.*/
    BoxIcons: "bi",
    /**Value: 'ci'.*/
    CircumIcons: "ci",
    /**Value: 'di'.*/
    Devicons: "di",
    /**Value: 'fi'. */
    Feather: "fi",
    /**Value: 'fc'.*/
    FlatColorIcons: "fc",
    /**Value: 'fa'. */
    FontAwesome5: "fa",
    /**Value: 'fa6'. */
    FontAwesome6: "fa6",
    /**Value: 'gi'. */
    GameIcons: "gi",
    /**Value: 'go' */
    GithubOcticonsIcons: "go",
    /**Value: 'gr'.*/
    GrommetIcons: "gr",
    /**Value: 'hi'.*/
    Heroicons: "hi",
    /**Value: 'hi2'.*/
    Heroicons2: "hi2",
    /**Value: 'im'.*/
    IcoMoonFree: "im",
    /**Value: 'lia'.*/
    Icons8LineAwesome: "lia",
    /**Value: 'io'.*/
    Ionicons4: "io",
    /**Value: 'io5'.*/
    Ionicons5: "io5",
    /**Value: 'lu'.*/
    Lucide: "lu",
    /**Value: 'md'.*/
    MaterialDesignIcons: "md",
    /**Value: 'pi'.*/
    PhosphorIcons: "pi",
    /**Value: 'rx'.*/
    RadixIcons: "rx",
    /**Value: 'ri'.*/
    RemixIcon: "ri",
    /**Value: 'si' */
    SimpleIcons: "si",
    /**Value: 'sl'.*/
    SimpleLineIcons: "sl",
    /**Value:'tb' */
    TablerIcons: "tb",
    /**Value: 'tfi'.*/
    ThemifyIcons: "tfi",
    /**Value: 'ti'.*/
    Typicons: "ti",
    /**Value: 'vsc'.*/
    VSCodeIcons: "vsc",
    /**Value: 'wi'.*/
    WeatherIcons: "wi",
    /**Value: 'cg'.*/
    Cssgg: "cg"
} as const;

export type IconFamilyEnumKeys = keyof typeof IconFamilyEnum;

export const GetIconFamilyValue = (key: IconFamilyEnumKeys) => IconFamilyEnum[key]?.trim();